@if (IS_TRS_PROJECT) {
  <div class="lay-wrapper trs lay-wrapper--home">
    <div class="background-image"></div>
    <div class="header">
      <h2>{{ "generic.main.homeText" | translate }} {{ currentUser?.userData?.fullName }}!</h2>
    </div>
    <div class="content">
      <div class="container">
        <div class="cards">
          @for (teaserBox of teasers; track teaserBox) {
            @if (isVisible(teaserBox, $index)) {
              <app-home-card [ngStyle]="{ background: teaserBox.backgroundColor }" [shadow]="'lg'" [teaserBox]="teaserBox">
                @if (!teaserBox.isSplit && items) {
                  <app-home-carousel
                    [auto]="true"
                    [controlColor]="teaserBox.controlColor"
                    [delay]="$index * 700"
                    [disabled]="teaserBox.disabled"
                    [itemList]="items[teaserBox.type]">
                    @switch (teaserBox.type) {
                      @case ("reports") {
                        @for (item of items.reports; track item.id) {
                          <app-report-tile (click)="setItem(item)" *carouselItem [auto]="true" [basic]="true" [item]="item" />
                        } @empty {
                          <app-report-tile *carouselItem [auto]="true" [basic]="true" [isPlaceholderLight]="true" [isPlaceholder]="true" />
                        }
                      }

                      @case ("glossary") {
                        @for (item of items.glossary; track item.id) {
                          <div
                            (click)="$event.stopPropagation(); showGlossary(item, teaserBox)"
                            *carouselItem
                            class="tab-container limit-height"
                            style="cursor: pointer">
                            <div class="tab-header">
                              <span>{{ currentLanguage === "en" ? item.title : item.titleDe }}</span>
                            </div>
                            <div [style.color]="teaserBox.fontColorText" class="tab-body">
                              <div [innerHTML]="currentLanguage === 'en' ? item.description : item.descriptionDe" class="editor-text"></div>
                            </div>
                          </div>
                        }
                      }

                      @case ("hyperlinks") {
                        @for (item of items.hyperlinks; track item.id) {
                          <div
                            (click)="$event.stopPropagation(); showGlossary(item, teaserBox)"
                            *carouselItem
                            class="tab-container limit-height"
                            style="cursor: pointer">
                            <a (click)="$event.stopPropagation()" [href]="item.urlLink" class="tab-header" target="_blank">
                              <span>{{ currentLanguage === "en" ? item.title : item.titleDe }}</span>
                            </a>
                            <div [style.color]="teaserBox.fontColorText" class="tab-body">
                              <span>{{ currentLanguage === "en" ? item.description : item.descriptionDe }}</span>
                            </div>
                          </div>
                        }
                      }

                      @case ("summary-reports") {
                        @for (item of items.summaries; track item.id) {
                          <app-summary-report-tile *carouselItem [auto]="true" [item]="item" />
                        } @empty {
                          <app-summary-report-tile *carouselItem [auto]="true" [isPlaceholderLight]="true" [isPlaceholder]="true" />
                        }
                      }
                    }
                  </app-home-carousel>
                }
              </app-home-card>
            }
          }
        </div>
      </div>
    </div>
  </div>
} @else if (IS_PRODUCT_SAFETY_PROJECT) {
  <div class="lay-wrapper product-safety">
    <div class="header">
      <h2>
        {{ "generic.main.homeText" | translate }} {{ currentUser?.userData?.fullName }}!
        <!-- @let message = getMessageForUser();
        @if (message.message) {
          <span [innerHTML]="message.message | translate: { dueDate: (message.variable | date) }"></span>
          @if (message.message === "generic.main.homeText.specialist-message.1") {
            <a (click)="faqService.toggleFaq()">FAQ SubUnits-Cascading</a>
          } @else if (message.message === "generic.main.homeText.specialist-message.2" || message.message === "generic.main.homeText.specialist-message.3") {
            <a routerLink="/reports">{{ "navigation.reports" | translate }}</a>
            <a (click)="faqService.toggleFaq()">Manual / FAQ 3 &amp; 4</a>
          }
        } -->
      </h2>
      <div>
        <app-home-tiles />
      </div>
    </div>
    <div class="content">
      <div class="container">
        <div class="cards">
          @for (teaserBox of teasers; track teaserBox) {
            @if (isVisible(teaserBox, $index)) {
              <app-home-card [ngStyle]="{ background: teaserBox.backgroundColor }" [shadow]="'lg'" [teaserBox]="teaserBox">
                @if (items) {
                  <app-home-carousel
                    [auto]="true"
                    [disabled]="teaserBox.disabled"
                    [controlColor]="teaserBox.controlColor"
                    [delay]="$index * 700"
                    [itemList]="items[teaserBox.type]">
                    @switch ($index) {
                      @case (0) {
                        @for (item of items.reports; track item.id) {
                          <app-report-tile (click)="setItem(item)" *carouselItem [auto]="true" [basic]="true" [item]="item" />
                        } @empty {
                          <app-report-tile *carouselItem [auto]="true" [basic]="true" [isPlaceholderLight]="true" [isPlaceholder]="true" />
                        }
                      }

                      @case (1) {
                        @for (item of items.glossary; track item.id) {
                          <div
                            (click)="$event.stopPropagation(); showGlossary(item, teaserBox)"
                            *carouselItem
                            class="tab-container limit-height"
                            style="cursor: pointer">
                            <div class="tab-header">
                              <span>{{ currentLanguage === "en" ? item.title : item.titleDe }}</span>
                            </div>
                            <div [style.color]="teaserBox.fontColorText" class="tab-body">
                              <div class="editor-text" [innerHTML]="currentLanguage === 'en' ? item.description : item.descriptionDe"></div>
                            </div>
                          </div>
                        }
                      }

                      @case (2) {
                        @for (item of items.hyperlinks; track item.id) {
                          <div
                            (click)="$event.stopPropagation(); showGlossary(item, teaserBox)"
                            *carouselItem
                            class="tab-container limit-height"
                            style="cursor: pointer">
                            <a (click)="$event.stopPropagation()" [href]="item.urlLink" class="tab-header" target="_blank">
                              <span>{{ currentLanguage === "en" ? item.title : item.titleDe }}</span>
                            </a>
                            <div [style.color]="teaserBox.fontColorText" class="tab-body">
                              <span>{{ currentLanguage === "en" ? item.description : item.descriptionDe }}</span>
                            </div>
                          </div>
                        }
                      }

                      @case (3) {
                        @for (item of items.summaries; track item.id) {
                          <app-summary-report-tile *carouselItem [auto]="true" [item]="item" />
                        } @empty {
                          <app-summary-report-tile *carouselItem [auto]="true" [isPlaceholderLight]="true" [isPlaceholder]="true" />
                        }
                      }
                    }
                  </app-home-carousel>
                }
              </app-home-card>
            }
          }
        </div>
      </div>
    </div>
  </div>
}

@if (selectedItem) {
  <div class="home-card-layer" (click)="selectedItem = null">
    <app-home-card
      [ngClass]="{ clicked: selectedItem === selectedItem }"
      [ngStyle]="{ background: selectedItem.teaser.backgroundColor }"
      [shadow]="'lg'"
      [teaserBox]="selectedItem.teaser"
      class="selected">
      <div class="tab-container">
        <div [style.color]="selectedItem.teaser.fontColorText" class="tab-body">
          <span [innerHTML]="currentLanguage === 'en' ? selectedItem.item.description : selectedItem.item.descriptionDe" class="editor-text"></span>
        </div>
      </div>
    </app-home-card>
  </div>
}
